"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _default = exports.default = {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,
  /** The header label that is used to display on smaller viewports above the cell's data. */
  headingLabel: _propTypes.default.string.isRequired,
  /** The data to populate inside of the cell. */
  value: _propTypes.default.any
};